import React, { useContext, useState } from 'react';
import {Redirect, withRouter} from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Container } from 'reactstrap';
import LoginFormComponent from './LoginFormComponent';
import Loader from '../Loader';
import { AuthContext } from '../../authentication';
import {HOME} from '../../navigation/routes';

import { errors } from '../FormElements';
const { REQUIRED, EMAIL } = errors;

const initialValues = {
  email: '',
  password: '',
};

const formSchema = Yup.object().shape({
  email: Yup.string().email(EMAIL).required(REQUIRED),
  password: Yup.string().required(REQUIRED)
});

const LoginFormContainer = ({location}) => {
  const {isAuth, login} = useContext(AuthContext); 
  const [isLogged, setLogged] = useState(isAuth);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState();
  const {from} = location.state || {from: {pathname: HOME}};

  const doLogin = async ({ email, password }, { setSubmitting, setStatus }) => {

    try {
      setError();
      setLoading(true);
      await login(email, password);
      setSubmitting(false);
      setLogged(true);
    } catch (er) {
      setLoading(false);
      setLogged(false);
      setError(
        { ...er,
          messaggio: 'Authentication error: '
        });
    }
  };
  
  return (
    isLogged ? <Redirect to={from} /> :
    <Container>
      <Loader isLoading={isLoading} />
      {!isLoading && <Formik
        initialValues={initialValues}
        validationSchema={formSchema}
        onSubmit={doLogin}
        render={props => <LoginFormComponent {...props} errore={error} />}
      />}
    </Container>
  );
};

LoginFormContainer.propTypes = {};

LoginFormContainer.defaultProps = {};

export default withRouter(LoginFormContainer);